import React from "react";
import { Container, Row, Col, Form, FormFeedback, Input, Label, Alert } from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import { sendResetPasswordMail } from "../../slices/thunks";

//redux
import { useSelector, useDispatch } from "react-redux";

//import images
import logolight from "../../assets/images/khozi.png";
import logoDark from "../../assets/images/khozi.png";
import { useFormik } from "formik";
import * as Yup from "yup";

const ResetPassword1 = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  document.title = "Recuperar Password | Khozi";

  const validation = useFormik({
      enableReinitialize: true,
      initialValues: {
        email: ""
      },
      validationSchema: Yup.object({
        email: Yup.string()
          .email("Por favor introduza um email válido")
          .required("Por favor introduza o seu email"),
      }),
      onSubmit: (values, { setSubmitting }) => {
        setSubmitting(true);
        dispatch(sendResetPasswordMail(values, navigate)).then(() => {
          setSubmitting(false);
        });        
      },
  }); 

  return (
    <React.Fragment>
      <div className="authentication-bg min-vh-100">
        <div className="bg-overlay bg-white"></div>
        <Container>
          <div className="d-flex flex-column min-vh-100 px-3 pt-4">
            <Row className="justify-content-center my-auto">
              <Col md={8} lg={6} xl={4}>
                <div className="text-center py-5">
                  <div className="mb-4 mb-md-5">
                    <Link to="/login" className="d-block auth-logo">
                      <img src={logoDark} alt="" height="120" className="auth-logo-dark"/>
                      <img src={logolight} alt="" height="120" className="auth-logo-light"/>
                    </Link>
                  </div>
                  <div className="text-muted mb-4">
                    <h5 className="">Recuperar palavra-passe</h5>              
                  </div>
                  {/*<Alert color="warning" className="text-center mb-4" role="alert">
                    Introduza o seu email e receberá instruções para redefinir a sua palavra-passe!
                  </Alert>*/}
                  <Form
                    onSubmit={e => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    <div className="form-floating form-floating-custom text-start mb-3">
                      <Input 
                        type="email" 
                        name = "email"
                        className="form-control" 
                        id="input-email"
                        placeholder="Introduza o seu email"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.email || ""}
                        invalid={
                          validation.touched.email &&
                          validation.errors.email ? true : false
                        }
                      />
                      {validation.touched.email &&
                      validation.errors.email ? (
                        <FormFeedback type="invalid">
                          {validation.errors.email}
                        </FormFeedback>
                      ) : null}
                      <Label htmlFor="input-email">Email</Label>
                      <div className="form-floating-icon">
                        <i className="uil uil-envelope-alt"></i>
                      </div>
                    </div>

                    <div className="mt-3">
                      <button className="btn btn-info w-100" type="submit" disabled={validation.isSubmitting}>
                        {validation.isSubmitting ? 'Enviando Pedido...' : 'Enviar Pedido'}
                      </button>                      
                    </div>
                  </Form>{" "}
                </div>
              </Col>
            </Row>

            <Row>
              <Col lg={12}>
                <div className="text-center text-muted p-4">
                  <p className="mb-0">
                    &copy; {new Date().getFullYear()} Khozi. Desenvolvido pela{" "}
                    <a href="http://casco.co.mz/" target="_blank" rel="noopener noreferrer">
                      CASCO
                    </a>
                  </p>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ResetPassword1;
